module.exports = __webpack_public_path__ + "images/pro/img-pro-storage-bg-f845b28ce046db3339a8302fc09bc80f.png";